module.exports = __webpack_public_path__ + "static/media/whiteHeartIcon.ea3b6ba8.svg";